import {
    PublicEmptyLegFilters,
    PublicEmptyLegMarketSortType,
    PublicEmptyLegSearchQuery,
    PublicEmptyLegSearchResult,
} from './types'

type SearchPublicEmptyLegsGateway = (query: PublicEmptyLegSearchQuery) => Promise<PublicEmptyLegSearchResult['emptyLegs']>

const snapshotFilters = (filters: PublicEmptyLegFilters): PublicEmptyLegFilters => ({
    ...filters,
    from_location: filters.from_location ? { ...filters.from_location } : null,
    destination_location: filters.destination_location ? { ...filters.destination_location } : null,
    dates: filters.dates ? {
        ...filters.dates,
        startDate: new Date(filters.dates.startDate),
        endDate: new Date(filters.dates.endDate),
    } : null,
})

export const buildPublicEmptyLegSearchQuery = (
    filters: PublicEmptyLegFilters,
    sort: PublicEmptyLegMarketSortType,
): PublicEmptyLegSearchQuery => {
    const query: PublicEmptyLegSearchQuery = { sort }

    if (filters.from) query.from = filters.from
    if (filters.destination) query.destination = filters.destination
    if (filters.dates?.startDate) query.startDate = filters.dates.startDate.toISOString()
    if (filters.dates?.endDate) query.endDate = filters.dates.endDate.toISOString()

    return query
}

export const executePublicEmptyLegSearch = async (
    filters: PublicEmptyLegFilters,
    sort: PublicEmptyLegMarketSortType,
    searchEmptyLegs: SearchPublicEmptyLegsGateway,
): Promise<PublicEmptyLegSearchResult> => {
    const search = snapshotFilters(filters)
    const query = buildPublicEmptyLegSearchQuery(search, sort)

    return {
        emptyLegs: await searchEmptyLegs(query),
        search,
    }
}
